import React, { useState } from 'react';
import { ExpandMore, ExpandLess, Link as LinkIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';

const FAQSection = ({ category, questions }) => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleQuestion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="space-y-4">
            {questions.map((item, index) => (
                <div
                    key={index}
                    className="bg-white border border-gray-200 rounded-xl overflow-hidden transition-all hover:shadow-md"
                >
                    <button
                        onClick={() => toggleQuestion(index)}
                        className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-inset"
                        aria-expanded={openIndex === index}
                    >
                        <span className="font-semibold text-gray-900 pr-4">{item.question}</span>
                        <div className="flex-shrink-0">
                            {openIndex === index ? (
                                <ExpandLess className="text-amber-600" />
                            ) : (
                                <ExpandMore className="text-gray-400" />
                            )}
                        </div>
                    </button>
                    {openIndex === index && (
                        <div className="px-6 pb-5 pt-2 border-t border-gray-100">
                            <div className="text-gray-700 leading-relaxed mb-4">
                                {item.answer}
                            </div>
                            {item.links && item.links.length > 0 && (
                                <div className="mt-4 pt-4 border-t border-gray-100">
                                    <p className="text-sm font-semibold text-gray-900 mb-2">En savoir plus :</p>
                                    <ul className="space-y-2">
                                        {item.links.map((link, linkIndex) => (
                                            <li key={linkIndex}>
                                                <Link
                                                    to={link.url}
                                                    className="text-amber-600 hover:text-amber-700 text-sm flex items-center space-x-2 hover:underline"
                                                >
                                                    <LinkIcon fontSize="small" />
                                                    <span>{link.text}</span>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default FAQSection;